/* All free solid fontawesome icons -> https://fontawesome.com/icons?d=gallery&s=brands&m=free */

import {
    faBootstrap,
    faCcAmex,
    faCcMastercard,
    faCcVisa,
    faFacebook,
    faFacebookF,
    faGithub,
    faGoogle,
    faHtml5,
    faTwitter,
} from '@fortawesome/free-brands-svg-icons';

export const fontAwesomeBrandsIcons = {
    faBootstrap,
    faCcAmex,
    faCcMastercard,
    faCcVisa,
    faFacebook,
    faFacebookF,
    faGithub,
    faGoogle,
    faHtml5,
    faTwitter,
};
